// const URL = process.env.NODE_ENV === 'production' ? 'http://app.abzschina.com/AnBang/' : 'http://localhost:21021/';
// const url = "http://localhost:21021/"
const url = "http://118.25.47.128:9090"
const URL = process.env.NODE_ENV === 'production' ? 'http://app.abzschina.com/AnBang/' : url;
export default URL;



// WEBPACK FOOTER //
// ./src/lib/url.ts